import React from "react";
import SEO from "../components/SEO";
import TitleSection from "@src/components/partials/training/TitleSection";
import FooterSection from "@src/components/partials/training/FooterSection";
import CtasSection from "@src/components/partials/training/CtasSection";
import UpcomingSection from "@src/components/partials/training/UpcomingTraining";
import EpisodesSection from "@src/components/partials/training/EpisodesSection";
import { useStaticQuery, graphql } from "gatsby";

const TrainingPage = () => {
  const data = useStaticQuery(graphql`
    query {
      youtube: file(name: { eq: "youtube" }) {
        childImageSharp {
          fixed(width: 90, quality: 90) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      twitter: file(name: { eq: "twitter" }) {
        childImageSharp {
          fixed(width: 90, quality: 90) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      certificate: file(name: { eq: "certificate" }) {
        childImageSharp {
          fixed(width: 90, quality: 90) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      contact: file(name: { eq: "contact" }) {
        childImageSharp {
          fixed(width: 90, quality: 90) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      community: file(name: { eq: "community" }) {
        childImageSharp {
          fixed(width: 90, quality: 90) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      resources: file(name: { eq: "resources" }) {
        childImageSharp {
          fixed(width: 90, quality: 90) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      epBlob1: file(name: { eq: "epBlob1" }) {
        childImageSharp {
          fixed(width: 65, quality: 90) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      epBlob2: file(name: { eq: "epBlob2" }) {
        childImageSharp {
          fixed(width: 65, quality: 90) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      epBlob3: file(name: { eq: "epBlob3" }) {
        childImageSharp {
          fixed(width: 65, quality: 90) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      epBlob4: file(name: { eq: "epBlob4" }) {
        childImageSharp {
          fixed(width: 65, quality: 90) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      directus {
        page_training {
          page_heading
          page_description
          ctas
          upcoming_training
        }
        page_training_22 {
          section
        }
      }
    }
  `);

  const {
    directus: {
      page_training: { page_heading, page_description, ctas, upcoming_training },
      page_training_22: { section },
    },
  } = data;
  return (
    <>
      <SEO
        title="ClassDojo Trainings"
        description="ClassDojo Trainings"
        twitter={{
          card: "",
          site: "",
          creator: "",
          title: "",
          description: "",
        }}
      />
      <TitleSection
        data={{
          page_heading,
          page_description,
        }}
      />
      {upcoming_training ? <UpcomingSection data={{ content: upcoming_training }} /> : ""}
      {section.map((s, index) => {
        return (
          <EpisodesSection
            key={index}
            data={s}
            blob={data[`epBlob${(index % 4) + 1}`].childImageSharp.fixed}
            index={index + 1}
          />
        );
      })}
      <CtasSection data={{ content: ctas, images: data }} />
      <FooterSection />
    </>
  );
};
export default TrainingPage;
